import type { TDictObject } from 'src/api/directories/types';

export const checkIsRegularDirectories = (directory: unknown): directory is TDictObject[] => {
  return Array.isArray(directory) && directory.every((dirValue) => checkIsRegularDirectory(dirValue));
};

export const checkIsRegularDirectory = (directory: unknown): directory is TDictObject => {
  return !!directory && typeof directory === 'object' && 'data' in directory && 'id' in directory;
};
